// PDF functionality commented out - entire file disabled
// This file contained PDF upload and management functionality for sanitaryware products
// All PDF-related features have been disabled as requested

import { useState, useEffect, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { sanitarywareService } from "../../../services/enhancedCrudService";
import { toast } from "react-toastify";
import {
  MAX_PDF_FILE_SIZE,
  MAX_PRODUCT_IMAGE_SIZE,
  MAX_PRODUCT_IMAGE_COUNT,
} from "./../../../shared/constant";
import { Crop } from "./../../../shared/crop";
import Swal from "sweetalert2";

const SanitarywarePdfs = () => {
  // PDF functionality completely commented out
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body text-center py-5">
            <h4>PDF Functionality Disabled</h4>
            <p className="text-muted">PDF upload and management features have been temporarily disabled.</p>
            <Link to="/products/sanitaryware" className="btn btn-primary">
              Back to Products
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SanitarywarePdfs;